import { gql } from '@apollo/client';

export const TYPE_IDENTITIES = gql`
  query TypeIdentities {
    typeIdentities {
      tiId
      tiPrefix
      tiName
      tiCode
    }
  }
`;

export const LOGIN_USER = gql`
  mutation login($input: IUserPayrollLogin!) {
    userAdminLogin(input: $input) {
      uId
      tokenAuth
      uState
      ucId
      uDoubleAuthRequired
      uDashboardAccess
      profileAdminUser {
        pauId
        pauFirNam
        pauSecNam
        pauFirLas
        pauSecLas
        pauEmail
        pauPhone
        pauCompany
      }
    }
  }
`;
